// @flow
import React, { Component } from 'react';

import SidebarContext from 'components/pages/User/Sidebar/SidebarContext';
import SidebarMenu from 'components/pages/User/Sidebar/SidebarMenu';

type Props = {};

type State = {
  isSidebarOpen: boolean,
  toggleSidebar: (showSidebar: boolean) => void
};

export const withSidebar = (WrappedComponent: any) =>
  class WithSidebar extends Component<Props, State> {
    state = {
      isSidebarOpen: false,
      toggleSidebar: (showSidebar: boolean) => {
        this.setState({ isSidebarOpen: showSidebar });
      }
    };

    render() {
      return (
        <SidebarContext.Provider value={this.state}>
          {this.state.isSidebarOpen && <SidebarMenu />}
          <WrappedComponent />
        </SidebarContext.Provider>
      );
    }
  };



// WEBPACK FOOTER //
// ./src/components/pages/User/Sidebar/SidebarContext/SidebarProvider.js